<template>
    <NuxtLayout>
        <NuxtPage :key="$route.fullPath" />
        <ConfirmDialogContainer />
    </NuxtLayout>
</template>